import { useContext } from 'react'

import { store } from 'modules/calendar/lib/calendarLeavesContext'

export const useCalendarLeaves = () => {
  const context = useContext(store)

  if (!context) {
    throw new Error('CalendarLeavesContext has not been properly set')
  }

  return context
}
